import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const links = ['מאמרים', 'ראיונות', 'תרבות', 'מחשבה', 'מנוי'];
  return <header className="w-full border-b border-ink/20 relative z-50" data-id="element-121">
      {/* Top thin bar */}
      <div className="flex justify-between items-center px-4 md:px-8 py-2 text-xs font-sans tracking-widest uppercase border-b border-ink/10 text-ink-soft" data-id="element-122">
        <span data-id="element-123">גיליון מס׳ 04</span>
        <span data-id="element-124">אביב 2026</span>
      </div>

      {/* Main Masthead */}
      <div className="flex flex-col items-center py-8 px-4 md:px-8" data-id="element-125">
        <div className="w-full flex justify-between items-center md:hidden mb-4" data-id="element-126">
          <button onClick={() => setIsOpen(!isOpen)} className="p-2 -mx-2 text-ink" data-id="element-127">
            {isOpen ? <X size={24} data-id="element-128" /> : <Menu size={24} data-id="element-129" />}
          </button>
          <span className="font-serif text-3xl font-black tracking-tight" data-id="element-130">
            קֶרֶן
          </span>
          <div className="w-6" data-id="element-131" /> {/* Spacer for centering */}
        </div>

        <h1 className="hidden md:block font-serif text-7xl md:text-9xl font-black tracking-tighter text-ink mb-6" data-id="element-132">
          קֶרֶן
        </h1>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-12 font-sans text-sm font-medium tracking-wide" data-id="element-133">
          {links.map(link => <a key={link} href={`#${link}`} className="text-ink hover:text-vermillion transition-colors relative group" data-id="element-134">
              {link}
              <span className="absolute -bottom-2 left-0 w-full h-px bg-vermillion scale-x-0 group-hover:scale-x-100 transition-transform origin-right" data-id="element-135" />
            </a>)}
        </nav>
      </div>

      {/* Mobile Nav Overlay */}
      <AnimatePresence data-id="element-136">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden border-t border-ink/10 bg-paper overflow-hidden" data-id="element-137">
            <nav className="flex flex-col px-4 py-6 gap-6 font-sans text-lg" data-id="element-138">
              {links.map(link => <a key={link} href={`#${link}`} onClick={() => setIsOpen(false)} className="text-ink hover:text-vermillion transition-colors" data-id="element-139">
                  {link}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}